import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0468abe2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "support-box"
};
const _hoisted_2 = {
  class: "support-tit"
};
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 支持的人 ");
const _hoisted_4 = {
  class: "info-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_people = _resolveComponent("people");
  const _component_CompPopupBottom = _resolveComponent("CompPopupBottom");
  return _openBlock(), _createBlock(_component_CompPopupBottom, {
    show: $props.show
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("i", {
      class: "close",
      onClick: _cache[0] || (_cache[0] = (...args) => $options.closePopup && $options.closePopup(...args))
    })]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_people, {
      list: $data.list,
      type: "project",
      onGetlist: $options.getNext,
      bottom_text: $data.bottom_text
    }, null, 8, ["list", "onGetlist", "bottom_text"])])])]),
    _: 1
  }, 8, ["show"]);
}